import { render, staticRenderFns } from "./MainBlock.vue?vue&type=template&id=0569f3c0&lang=pug&"
import script from "./MainBlock.vue?vue&type=script&lang=js&"
export * from "./MainBlock.vue?vue&type=script&lang=js&"
import style0 from "./MainBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports